import { boot } from "quasar/wrappers";
import VueSocialSharing from "vue-social-sharing";

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ app }) => {
  // something to do
  console.log("social sharing loaded");
  app.use(VueSocialSharing);
});
